import { Link } from "react-router-dom";

interface Props {
  icon?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  icon,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
}: Props) {
  return (
    <div className="mb-4 flex items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900 md:text-xl">
          {icon && <i className={`${icon} text-primary-600`} />}
          {title}
        </h2>
        {desc && <p className="mt-1 text-sm text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-700 whitespace-nowrap"
        >
          {moreLabel} <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}